module.exports = __webpack_public_path__ + "img/2025-id.7c2579b4.jpg";